// extracted by mini-css-extract-plugin
export var animationContainer = "SortPlayer-module--animationContainer--0NpM2";
export var cardContainer = "SortPlayer-module--cardContainer--0dejD";
export var colorPreview = "SortPlayer-module--colorPreview--DEFJN";
export var legendContainer = "SortPlayer-module--legendContainer--TqcEJ";
export var playerButton = "SortPlayer-module--playerButton--i1FIn";